import {
  useQueryClient,
  useQuery,
  useMutation,
  keepPreviousData,
} from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import { getFinishedProductsList } from "../api/PosSyncApi";
import qs from "qs";

const finishedProductsWithoutPLUKeys = {
  all: ["finishedProductsWithoutPlu"],
  lists: () => [...finishedProductsWithoutPLUKeys.all, "lists"],
  productslist: (filters) => [
    ...finishedProductsWithoutPLUKeys.lists(),
    filters,
  ],
};

export const useFinishedProductsWithoutPLUQueries = ({
  selectedCategory,
  selectedType,
  selectedStatus,
  selectedSubCategory,
  debouncedText,
}) => {
  const queryClient = useQueryClient();
  let params = {};

  if (selectedCategory?.length > 0) {
    params = {
      ...params,
      category_id: selectedCategory?.map((item) => item.id),
    };
  }
  if (selectedSubCategory?.length > 0) {
    params = {
      ...params,
      subcategory_id: selectedSubCategory?.map((item) => item.id),
    };
  }
  if (debouncedText) {
    params = { ...params, search: debouncedText };
  }

  if (selectedType !== "") {
    params = { ...params, type: selectedType };
  }
  if (selectedStatus !== "") {
    params = { ...params, status: selectedStatus };
  }

  const query = {
    params,
    paramsSerializer: (params) => qs.stringify(params, { encode: true }),
  };

  //list useQueryClient
  const listQuery = useQuery({
    queryKey: finishedProductsWithoutPLUKeys.productslist({ query }),
    queryFn: () => getFinishedProductsList({ query }),
    placeholderData: keepPreviousData,
    enabled: true,
  });

  return {
    listQuery,
  };
};
